module.exports = __webpack_public_path__ + "static/img/molokai.a76f5326.jpg";